import { ShoppingBag, ChefHat, Utensils, Info, CreditCard, ShieldAlert, Megaphone } from 'lucide-react';
import type React from 'react';
import type { NotificationCategory } from '../types/notifications';

export const CATEGORY_ICON_MAP: Record<NotificationCategory, React.ElementType> = {
  order: ShoppingBag,
  kitchen: ChefHat,
  table: Utensils,
  system: Info,
  billing: CreditCard,
  security: ShieldAlert,
  campaign: Megaphone,
};

export const CATEGORY_LABEL_MAP: Record<NotificationCategory, string> = {
  order: 'Orders',
  kitchen: 'Kitchen',
  table: 'Table Calls',
  system: 'System',
  billing: 'Billing',
  security: 'Security',
  campaign: 'Campaigns',
};

export const CATEGORY_STYLE_MAP: Record<NotificationCategory, { bg: string; text: string; border: string }> = {
  order:    { bg: 'bg-emerald-500/10', text: 'text-emerald-400', border: 'border-emerald-500/20' },
  kitchen:  { bg: 'bg-orange-500/10',  text: 'text-orange-400',  border: 'border-orange-500/20'  },
  table:    { bg: 'bg-amber-500/10',   text: 'text-amber-400',   border: 'border-amber-500/20'   },
  system:   { bg: 'bg-blue-500/10',    text: 'text-blue-400',    border: 'border-blue-500/20'    },
  billing:  { bg: 'bg-purple-500/10',  text: 'text-purple-400',  border: 'border-purple-500/20'  },
  security: { bg: 'bg-red-500/10',     text: 'text-red-400',     border: 'border-red-500/20'     },
  campaign: { bg: 'bg-pink-500/10',    text: 'text-pink-400',    border: 'border-pink-500/20'    },
};
